import { ConsoleLogger, Injectable, Scope } from '@nestjs/common';
import config from 'config';
import { createLogger } from 'winston';
import SentryTransport from 'winston-transport-sentry-node';

@Injectable({ scope: Scope.TRANSIENT })
export class WinstonLogger extends ConsoleLogger {
  private readonly logger;

  constructor() {
    super();
    this.logger = createLogger({ transports: [new SentryTransport({ level: 'error', sentry: { ...config.get('sentry') } })] });
  }

  public override debug(message: string): void {
    super.debug(message);
    this.logger.debug(message);
  }

  public override error(message: string, trace?: string): void {
    super.error(message, trace || '');
    this.logger.error(message, trace);
  }

  public override log(message: string): void {
    super.log(message);
    this.logger.info(message);
  }

  public override verbose(message: string): void {
    super.verbose(message);
    this.logger.verbose(message);
  }

  public override warn(message: string): void {
    super.warn(message);
    this.logger.warn(message);
  }
}
